import React, {FC, useEffect, useMemo} from 'react'
import {Column} from 'react-table'
import {useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {TabCentralModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useCentral} from '../../../../../../hooks/useCentral'
import {PersonModel} from '../../../../model'
import {getPerson} from '../../../../services'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {useTableMaster} from '../../../../hooks'
const TablePerson: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()
  const {searchValues, clearSearchValues} = useKhipu()
  const {docType, getDocTypeList, statusUser, getStatusUserList} = useTableMaster()

  const getPersonList = async () => {
    try {
      setLoading(true)
      const {data: response} = await getPerson(searchValues, pagination.currentPage)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  useEffect(() => {
    getDocTypeList()
    getStatusUserList()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if (currentTabItem.loadingTable || pagination.currentPage) {
      if (currentTabItem.loadingTable) {
        clearSelected()
        setUpdateTable(false)
      }
      getPersonList()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, currentTabItem.loadingTable])
  useEffect(() => {
    if (updateTable) {
      if (pagination.currentPage === 1) {
        getPersonList()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTable(false)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])
  const handleViewPanel = (rowData: any) => {
    const getRow = rowData.row
    const getArrows = rowData.data
    const getData = getArrows[getRow.index]
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.id,
      currentExternalTab: 0,
      fromCreateButton: false,
      content: {
        ...currentTabItem.content,
        detailPanel: 'tab-document',
      },
      idToDelete: '',
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    console.log(idChange)
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<PersonModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} showSelect={false} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].id}
            clickHandler={handleGetId}
          />
        ),
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de documento'
            name='tipoDocumento'
            data={docType}
            selecteable
          />
        ),
        accessor: 'tipoDocumentoNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Número de documento'
            name='numeroDocumento'
            searcheable
          />
        ),
        accessor: 'numeroDocumento',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nombres' name='nombres' searcheable />
        ),
        accessor: 'nombres',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Apellido Paterno'
            name='apellidoPaterno'
            searcheable
          />
        ),
        accessor: 'apellidoPaterno',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Apellido Materno'
            name='apellidoMaterno'
            searcheable
          />
        ),
        accessor: 'apellidoMaterno',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado'
            name='estado'
            data={statusUser}
            selecteable
          />
        ),
        accessor: 'estado',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}
          </>
        ),
      },
    ],
    [docType, statusUser, selectedOn],
  )

  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='w-100'>
          <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

export {TablePerson}
